// src/components/EmojiBackground.js
import React from 'react';
import './EmojiBackground.css';

function EmojiBackground() {
  return (
    <>
      <div className="emoji emoji1">🍺</div>
      <div className="emoji emoji2">🍷</div>
      <div className="emoji emoji3">🍹</div>
      <div className="emoji emoji4">🍻</div>
      <div className="emoji emoji5">🍸</div>
      <div className="emoji emoji6">🍺</div>
      <div className="emoji emoji7">🍷</div>
    </>
  );
}

export default EmojiBackground;
